import { render, staticRenderFns } from "./HolidayPeriodEditPage.vue?vue&type=template&id=5cefd630&scoped=true&"
import script from "./HolidayPeriodEditPage.vue?vue&type=script&lang=ts&"
export * from "./HolidayPeriodEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./HolidayPeriodEditPage.vue?vue&type=style&index=0&id=5cefd630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cefd630",
  null
  
)

export default component.exports